import { render, staticRenderFns } from "./SelectTechProposal.vue?vue&type=template&id=383d38c7"
import script from "./SelectTechProposal.vue?vue&type=script&lang=js"
export * from "./SelectTechProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports